<form [formGroup]="formGroup">
  @for (element of elements; track element.name) {
    @if (element.type === "section") {
      <div class="section">
        <b class="section-title">{{ element.title }}</b>
      </div>
    }
    @if (element.type === "boolean") {
      <div class="q-row">
        <div class="q-label">
          <b class="title"
            >{{ questionNumber(element) }}.
            {{ getQuestionTitle(element.title) }}</b
          >
          @if (getQuestionInstruction(element.title)) {
            <div class="question-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>

        <div class="q-control a-index">
          <nz-radio-group
            class="boolean-segment"
            [nzButtonStyle]="'solid'"
            [formControlName]="element.name"
          >
            <label
              nz-radio-button
              [nzValue]="false"
              (click)="onRadioClick($event, element.name, false)"
            >
              <span>{{ element.labelFalse || ("No" | translate) }}</span>
            </label>

            <label
              nz-radio-button
              [nzValue]="true"
              (click)="onRadioClick($event, element.name, true)"
            >
              <span>{{ element.labelTrue || ("Yes" | translate) }}</span>
            </label>
          </nz-radio-group>
        </div>
      </div>
    }
    @if (element.type === "radiogroup") {
      <div class="q-row">
        <div class="q-label">
          <b class="title"
            >{{ questionNumber(element) }}.
            {{ getQuestionTitle(element.title) }}</b
          >
          @if (getQuestionInstruction(element.title)) {
            <div class="question-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>

        <div class="q-control a-index">
          <nz-radio-group
            class="boolean-segment"
            [nzButtonStyle]="'solid'"
            [formControlName]="element.name"
          >
            @for (choice of element.choices; track choice.value) {
              <label
                nz-radio-button
                [nzValue]="choice.value"
                (click)="onRadioClick($event, element.name, choice.value)"
              >
                <span>{{ choice.text }}</span>
              </label>
            }
          </nz-radio-group>
        </div>
      </div>
    }
  }

  <div
    class="dn4-total"
    [ngClass]="{
      'dn4-total-positive': isPositive,
      'dn4-total-negative': !isPositive,
    }"
  >
    <div class="dn4-total-title">{{ "Score" | translate }}</div>
    <div class="dn4-total-score">{{ totalScore }} / {{ maxScore }}</div>
    <div class="dn4-total-status">
      {{
        (isPositive ? "DN4_PositiveResult" : "DN4_NegativeResult") | translate
      }}
    </div>
    <div class="dn4-total-notes">
      <p>{{ "DN4_ScoringRule" | translate }}</p>
      <p>{{ "DN4_InterpretationNote" | translate }}</p>
    </div>
  </div>
</form>